import React from "react";
import { Form, Input, Button, Checkbox } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import md5 from "js-md5";
import { requestLogin } from "./service";
import styles from "./index.module.less";

const Login = (props) => {
  const navigate = useNavigate();
  const [confirmLoading, changeConfirmLoading] = React.useState(false);
  const onFinish = async (values) => {
    changeConfirmLoading(true);
    const res = await requestLogin({
      userName: values.userName,
      passWord: md5(values.passWord),
    });
    changeConfirmLoading(false);
    if (res.data) {
      navigate("/", { replace: true });
      props.getUserInfo();
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <div className={`page ${styles["page-login"]}`}>
      <Form
        name="basic"
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        initialValues={{ remember: true }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
        className="page-login-form"
      >
        <Form.Item
          label="用户名"
          name="userName"
          rules={[{ required: true, message: "请输入工号" }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="密码"
          name="passWord"
          rules={[{ required: true, message: "请输入密码" }]}
        >
          <Input.Password />
        </Form.Item>

        <Form.Item
          name="remember"
          valuePropName="checked"
          wrapperCol={{ offset: 8, span: 16 }}
        >
          <Checkbox>忘记密码</Checkbox>
        </Form.Item>

        <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
          <Button
            type="primary"
            htmlType="submit"
            loading={confirmLoading}
            className="submit-btn"
          >
            登录
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default Login;
